import * as avatarV3 from './avatarV3';
import * as bookRecordQueryV3 from './bookRecordQueryV3';
import * as feedbackV3 from './feedbackV3';
import * as meetingCallV3 from './meetingCallV3';
import * as meetingCameraControlV3 from './meetingCameraControlV3';
import * as meetingCodeEditorV3 from './meetingCodeEditorV3';
import * as meetingInterpretChannelV3 from './meetingInterpretChannelV3';
import * as meetingRecordV3 from './meetingRecordV3';
import * as meetingRecordingV3 from './meetingRecordingV3';
import * as meetingScreenShareV3 from './meetingScreenShareV3';
import * as meetingSubtitleV3 from './meetingSubtitleV3';
import * as meetingV3 from './meetingV3';
import * as meetingWhiteboardV3 from './meetingWhiteboardV3';
import * as memberV3 from './memberV3';
import * as reaction from './reaction';
import * as settingV3 from './settingV3';

export const client = {
  avatarV3,
  bookRecordQueryV3,
  feedbackV3,
  meetingCallV3,
  meetingCameraControlV3,
  meetingCodeEditorV3,
  meetingInterpretChannelV3,
  meetingRecordV3,
  meetingRecordingV3,
  meetingScreenShareV3,
  meetingSubtitleV3,
  meetingV3,
  meetingWhiteboardV3,
  memberV3,
  reaction,
  settingV3,
};
